var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex items-center flex-shrink-0 p-4 text-sm",class:[_vm.alignmentClass, _vm.className, {
        'overflow-hidden': _vm.truncate,
    }]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }